export * from './ExtracaoPadrao'